module.exports = __webpack_public_path__ + "img/liaoning.50adc20d.png";